export const SET_DATA = 'payment/SET_DATA';
export const SET_PAYMENT_STATUS = 'payment/SET_PAYMENT_STATUS';
export const CANCEL_SUBSCRIPTION = 'payment/CANCEL_SUBSCRIPTION';
